import axiosInstance from "./apiinterseptor";

export const getMyHighlights = async (dateFrom?: string, dateTo?: string) => {
    const response = await axiosInstance.get(`/highlights/my-highlights?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    return response.data;
};


export const getHighlightsDailySeries = async (
    metric: string,
    dateFrom: string,
    dateTo: string
) => {
    const params = new URLSearchParams();
    params.set("metric", metric);
    params.set("dateFrom", dateFrom);
    params.set("dateTo", dateTo);
    const response = await axiosInstance.get(`/highlights/daily-series?${params.toString()}`);
    return response.data;
};

export const getHighlightsTableData = async (
    page: number, 
    dateFrom?: string, 
    dateTo?: string, 
    limit: number = 10,
    search?: string,
    role?: string,
    managerId?: string,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc'
) => {
    const params = new URLSearchParams();
    params.set('page', page.toString());
    params.set('limit', limit.toString());
    if (dateFrom) params.set('dateFrom', dateFrom);
    if (dateTo) params.set('dateTo', dateTo);
    if (search) params.set('search', search);
    if (role) params.set('role', role);
    if (managerId) params.set('managerId', managerId);
    if (sortBy) params.set('sortBy', sortBy);
    if (sortOrder) params.set('sortOrder', sortOrder);
    
    const response = await axiosInstance.get(`/highlights/table-data?${params.toString()}`);
    return response.data;
};